import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "@/components/store/Reveal";

export default function Learn() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28 md:pt-36 pb-24" data-testid="learn-page">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <p className="overline text-terracotta mb-3">The Journal</p>
          <h1 className="font-serif text-5xl md:text-7xl text-espresso tracking-tight mb-4">Learn skincare</h1>
          <p className="text-bark max-w-xl mb-14">
            Educate first. Read our guides on routines, ingredients and the mistakes to avoid before you shop.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-x-8 gap-y-14">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.1}>
              <Link to={`/learn/${p.id}`} className="group block" data-testid={`blog-card-${p.id}`}>
                <div className="overflow-hidden rounded-2xl aspect-[16/10] bg-sand mb-5">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="flex gap-2 mb-3">
                  {(p.tags || []).map((t) => (
                    <span key={t} className="overline text-moss">{t}</span>
                  ))}
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-espresso leading-tight group-hover:text-terracotta transition-colors flex items-start gap-2">
                  {p.title}
                  <ArrowUpRight className="w-5 h-5 mt-1 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
                </h2>
                <p className="text-bark mt-2 line-clamp-2">{p.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
